import { Component, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Corporation, ForwarderService, PagerService, AlertService, CommonService, TableHeader, RequestOwner } from '../../services/index'
import { REST_API_REQUEST_CALL_URL, Util } from '../../utils/index';
import { Router } from '@angular/router';
declare var $:any;
import _ from 'lodash';



@Component({
  selector: 'fwdr-owner',
  templateUrl: 'fwdr-owner.html' 
})
export class FwdrOwnerContainer {
  getCorpListSub:Subscription;
  updateCorpStatusSub:Subscription;

  phoneFormatter: Function = Util.phoneFormatter;
  createRange: Function = Util.createRange;
  corpRegFormatter: Function = Util.corpRegFormatter;
  fwdrList:Array<Corporation>;
  tempFwdrList:Array<Corporation>;
  pager: any = {};
  pagedItems:any[];
  searchOption:SearchOption = new SearchOption();
  headerList:Array<TableHeader> = null;
  clickedHader:TableHeader;
  apiUrl: string = '';

  @Output() headerSortedEmit: EventEmitter<any> = new EventEmitter();
  @Output() clearHeaderEmit: EventEmitter<any> = new EventEmitter();
  

  constructor(
    private fwdrMngService: ForwarderService, 
    private pagerService: PagerService, 
    private alertService:AlertService, 
    private router:Router, 
    private commonService:CommonService,
  ) {

    commonService.headerSortedEmit.subscribe(sortedData =>{
      this.tempFwdrList = sortedData;
      this.setPage(1);
    });
    commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  }
  
  ngOnInit() {

    if(this.fwdrMngService.fwdrOwnerSearchOption != null){
      this.searchOption = this.fwdrMngService.fwdrOwnerSearchOption;
    }

    if(this.fwdrMngService.fwdrOwnerPager != null){
      this.pager = this.fwdrMngService.fwdrOwnerPager;
      this.search(this.pager.currentPage);
    }else{
      this.search(1);
    }

    if(this.fwdrMngService.fwdrOwnerHeader != null){
      this.headerList = this.fwdrMngService.fwdrOwnerHeader;
    }else{
      this.makeHeader();
    }

    this.apiUrl = REST_API_REQUEST_CALL_URL.BASE_URL;
  }

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'corpId', 'No.', true));
    this.headerList.push(new TableHeader(1, 'statusCd', '상태구분', true));
    this.headerList.push(new TableHeader(2, 'corpNm', '회사명', true));
    this.headerList.push(new TableHeader(3, 'lastNm', '요청자명', true));
    this.headerList.push(new TableHeader(4, 'email', '요청자 이메일', true));
    this.headerList.push(new TableHeader(5, 'tel', '요청자 연락처', false));
    this.headerList.push(new TableHeader(6, 'eco', '대표자명', false));
    this.headerList.push(new TableHeader(7, 'tel', '연락처', false));
    this.headerList.push(new TableHeader(8, 'corpRegNo', '사업자번호', false));
    this.headerList.push(new TableHeader(9, 'corpRegFileNm', '사업자등록증', false));
    this.headerList.push(new TableHeader(10, 'url', '홈페이지', false));
    this.headerList.push(new TableHeader(11, 'address', '본사주소', false));
    this.headerList.push(new TableHeader(12, 'statusCd', '승인하기', false));
    
  }

  ngOnDestroy(){
    if(this.getCorpListSub) this.getCorpListSub.unsubscribe();
    if(this.updateCorpStatusSub) this.updateCorpStatusSub.unsubscribe();
  }

  search(page){
    this.getCorpListSub = this.fwdrMngService.getRequestCorpOwnerList().subscribe((res:any)=>{
      this.fwdrList = res.data;
      this.tempFwdrList = this.fwdrList;

      if(this.fwdrMngService.fwdrOwnerClickedHeader != null){
        this.clickedHader = this.fwdrMngService.fwdrOwnerClickedHeader;
        
        if(this.clickedHader.orderBy.indexOf("ASC") > -1){
          this.clickedHader.orderBy = 'DESC';
        }else{
          this.clickedHader.orderBy = 'ASC';
        }

        this.commonService.headerClick(this.clickedHader, this.tempFwdrList);
      }

      this.conditionSearch(page);
    });
  }
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.tempFwdrList.length, page);
    // if (page < 1) {
    //   return;
    // } 
    
    this.pagedItems = this.tempFwdrList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    
  }

  approvalCorpOwner(ownerReuqestUserInfo, event){
    event.stopPropagation();
    let that = this;
    $.sweetModal.confirm("승인상태로 변경하시겠습니까?", function() {
      that.updateCorpStatusSub = that.fwdrMngService.patchRequestOwner(ownerReuqestUserInfo.userId).subscribe(
        res=>{
          if(res.result){
            that.alertService.success('상태 변경이 완료되었습니다.');
            that.search(that.pager.currentPage);
          }
        }
      );
    });
  }

  conditionSearch(page?:number){
    if(_.isEmpty(this.fwdrList)) return;
    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    let statusCd = this.searchOption.conditionType;
    this.tempFwdrList = _.map(_.filter(this.fwdrList,
      (fwdr:RequestOwner) => {
        let lastName = '';
        let firstName = '';
        let tempEmail = '';
        if(fwdr.ownerReuqestUserInfo){
          lastName = fwdr.ownerReuqestUserInfo.lastNm ? fwdr.ownerReuqestUserInfo.lastNm : '';
          firstName = fwdr.ownerReuqestUserInfo.firstNm ? fwdr.ownerReuqestUserInfo.firstNm : '';
          tempEmail = fwdr.ownerReuqestUserInfo.email ? fwdr.ownerReuqestUserInfo.email : '';
        }
        if(!keyword) return true;
        else if (_.upperCase(fwdr.tel ? fwdr.tel : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(lastName + firstName).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(fwdr.corpNm ? fwdr.corpNm : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(fwdr.corpRegNo ? fwdr.corpRegNo : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(tempEmail ? tempEmail : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else return false;
      }));
    this.tempFwdrList = _.map(_.filter(this.tempFwdrList,
      (fwdr:RequestOwner) => {
        if(statusCd == 'ALL') return true;
        else if(fwdr.statusCd == statusCd) return true;
        else return false;
      }));
    this.setPage(page == null || page == undefined ? 1 : page);
    this.commonService.clearOrderByHeader(this.headerList);
  }
  selectConditionType(event){
    this.searchOption.conditionType = event;
    this.conditionSearch();
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch();
  }

  moveFwdrDetail(corpId){
    this.fwdrMngService.fwdrOwnerPager = this.pager;
    this.fwdrMngService.fwdrOwnerSearchOption = this.searchOption;
    this.fwdrMngService.fwdrOwnerClickedHeader = this.clickedHader;
    this.fwdrMngService.fwdrOwnerHeader = this.headerList;

    this.router.navigate(['/fwdr/setting', corpId]);
  }

  headerClick(header:TableHeader){
    this.clickedHader = header;
    this.fwdrMngService.fwdrOwnerClickedHeader = header;
    this.commonService.headerClick(header, this.tempFwdrList);
  }

}

class SearchOption {
  conditionText:string;
  conditionType:string = 'ALL';
}



// WEBPACK FOOTER //
// ./src/app/containers/fwdr-owner/fwdr-owner.ts